module.exports = __webpack_public_path__ + "img/anamnez.9f117cce.gif";